/**
 * サンプル解析パネル
 *
 * テスト用画像/PDFのアップロードと解析結果表示
 */

import { Stack, Box } from "@mantine/core";
import { FileUploader } from "./FileUploader";
import { AnalysisResultsTable } from "./AnalysisResultsTable";

interface SampleAnalyzerProps {
  // ファイル選択
  selectedFile: File | null;
  onFileSelect: (file: File | null) => void;
  // 解析
  analyzing: boolean;
  onExecuteAnalysis: () => void;
  // プレビュー
  previewUrl: string | null;
  // 解析結果
  analysisResult: Record<string, unknown> | null;
  errorMessage: string | null;
  // 使用されたプロンプト
  promptUsed?: string | null;
}

export function SampleAnalyzer({
  selectedFile,
  onFileSelect,
  analyzing,
  onExecuteAnalysis,
  previewUrl,
  analysisResult,
  errorMessage,
  promptUsed,
}: SampleAnalyzerProps) {
  return (
    <Box style={{ position: "sticky", top: "1rem" }}>
      <Stack gap="xs">
        <FileUploader
          selectedFile={selectedFile}
          onFileSelect={onFileSelect}
          analyzing={analyzing}
          onExecuteAnalysis={onExecuteAnalysis}
          previewUrl={previewUrl}
        />
        <AnalysisResultsTable
          analyzing={analyzing}
          analysisResult={analysisResult}
          errorMessage={errorMessage}
          promptUsed={promptUsed}
        />
      </Stack>
    </Box>
  );
}
